if (!customElements.get('wetsuit-weight-selector')) {
  customElements.define(
    'wetsuit-weight-selector',
    class WetsuitWeightSelector extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.form = this.closest('form');
        this.range = this.querySelector('[data-weight-range]');
        this.propertyInput = this.querySelector('[data-weight-property]');
        this.output = this.querySelector('[data-weight-output]');
        this.helpButton = this.querySelector('[data-weight-help]');
        this.dialog = this.querySelector('[data-weight-dialog]');
        this.dialogTitle = this.querySelector('[data-weight-dialog-title]');
        this.dialogCopy = this.querySelector('[data-weight-dialog-copy]');

        if (!this.form || !this.range || !this.propertyInput || !this.output || !this.dialog) return;

        this.range.addEventListener('input', () => this.selectWeight());
        this.range.addEventListener('change', () => this.selectWeight());
        this.range.addEventListener('pointerup', () => this.selectWeight());
        this.range.addEventListener('keyup', (event) => {
          if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) {
            this.selectWeight();
          }
        });
        this.helpButton?.addEventListener('click', () => this.openHelpDialog());
        this.querySelectorAll('[data-weight-dialog-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog.close());
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          if (this.focusRangeOnClose) this.range.focus({ preventScroll: true });
          this.focusRangeOnClose = false;
        });

        this.form.addEventListener('submit', (event) => this.validateSelection(event), true);
        this.form.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('.shopify-payment-button__button')) this.validateSelection(event);
          },
          true
        );

        this.updateProgress();
      }

      selectWeight() {
        const value = Number.parseInt(this.range.value, 10);
        const unit = this.dataset.unit;

        this.dataset.selected = 'true';
        this.range.setAttribute('aria-invalid', 'false');
        this.propertyInput.disabled = false;
        this.propertyInput.value = `${value} ${unit}`;
        this.output.textContent = `${value} ${unit}`;
        this.updateProgress();
      }

      updateProgress() {
        const minimum = Number.parseInt(this.range.min, 10);
        const maximum = Number.parseInt(this.range.max, 10);
        const value = Number.parseInt(this.range.value, 10);
        const progress = maximum === minimum ? 0 : ((value - minimum) / (maximum - minimum)) * 100;
        this.style.setProperty('--weight-progress', `${progress}%`);
      }

      validateSelection(event) {
        if (this.dataset.selected === 'true' && this.propertyInput.value) return true;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.range.setAttribute('aria-invalid', 'true');
        this.focusRangeOnClose = true;
        this.openDialog(this.dataset.validationTitle, this.dataset.validationBody);
        return false;
      }

      openHelpDialog() {
        this.focusRangeOnClose = false;
        this.openDialog(this.dataset.helpTitle, this.dataset.helpBody);
      }

      openDialog(title, body) {
        this.dialogTitle.textContent = title;
        this.dialogCopy.textContent = body;
        this.dialog.setAttribute('aria-label', title || body);

        if (typeof this.dialog.showModal === 'function') {
          if (!this.dialog.open) this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
      }
    }
  );
}
